module.exports = __webpack_public_path__ + "img/Trending-Down.9e8b8cb7.svg";